import { useEffect, useRef, useState } from 'react';

const SCROLL_DIR_VISIBILITY_EVENT = 'scroll-dir-visibility';

interface ScrollDirVisibilityEventDetail {
  visible?: boolean;
  fixed?: boolean;
}

export const emitScrollDirVisibility = (detail: ScrollDirVisibilityEventDetail) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<ScrollDirVisibilityEventDetail>(SCROLL_DIR_VISIBILITY_EVENT, {
      detail
    })
  );
};

export const useVisibleByScrollDir = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFixed, setIsFixed] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isScrolled = scrollY > 0;

      setIsFixed(isScrolled);

      if (scrollY < 10) {
        setIsVisible(true);
      } else {
        setIsVisible(scrollY <= lastScrollY.current);
      }

      lastScrollY.current = scrollY;
    };

    const handleExternalVisibility = (event: Event) => {
      const detail = (event as CustomEvent<ScrollDirVisibilityEventDetail>).detail;

      if (detail?.visible !== undefined) {
        setIsVisible(detail.visible);
      }

      if (detail?.fixed !== undefined) {
        setIsFixed(detail.fixed);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    window.addEventListener(SCROLL_DIR_VISIBILITY_EVENT, handleExternalVisibility);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      window.removeEventListener(SCROLL_DIR_VISIBILITY_EVENT, handleExternalVisibility);
    };
  }, []);

  return {
    isVisible,
    isFixed,
    setIsVisible,
    setIsFixed
  };
};
